/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BluetoothX(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Path d="M188.7998,169.60254,133.333,128.00244l23.46679-17.6001a7.9998,7.9998,0,1,0-9.59961-12.7998L128,112.00244v-64l19.19922,14.39893a7.99981,7.99981,0,0,0,9.59961-12.79981l-31.999-23.999A8,8,0,0,0,112,32.00244v80.00025L60.7998,73.60254a7.9998,7.9998,0,0,0-9.59961,12.7998l55.4668,41.6001-55.4668,41.6001a7.9998,7.9998,0,1,0,9.59961,12.7998L112,144.0022v80.00024a7.99975,7.99975,0,0,0,12.7998,6.3999l64-48a7.9995,7.9995,0,0,0,0-12.7998ZM128,208.00244v-64l42.6665,32Z" />
        <Path d="M219.31348,80l18.34326-18.34326a7.99984,7.99984,0,0,0-11.31348-11.31348L208,68.68652,189.65674,50.34326a7.99984,7.99984,0,0,0-11.31348,11.31348L196.68652,80,178.34326,98.34326a7.99984,7.99984,0,1,0,11.31348,11.31348L208,91.31348l18.34326,18.34326a7.99984,7.99984,0,1,0,11.31348-11.31348Z" />
      </G>
    </Svg>
  );
}

export default BluetoothX;
